import Vue from 'vue'
import {map, includes, pickBy, orderBy, forEach} from "lodash";
import api from "../../../api/api";
import {stateMerge} from "../../object-merge";
import {dzinCategoryIds, hzsCategoryIds} from "@/store/modules/events";

export const RESOLVER_CONTACT_TYPE_ID = 22;
export const DISP_DZIN_CONTACT_TYPE_ID = 19;
export const OIS_CONTACT_TYPE_ID = 2;


const getDefaultState = () => {
    return {
        local: {},
    }
};
const state = getDefaultState();

const getters = {
    getByEvent: (state) => {
        return (key) => {
            return orderBy(pickBy(state.local, function (item) {
                return item != null && item.eventUuid === key;
            }), ['sort'], ['asc']);
        }
    },
    getByEventId: (state) => {
        return (eventId) => {
            return orderBy(pickBy(state.local, function (item) {
                return item != null && item.eventId === eventId;
            }), ['sort'], ['asc']);
        }
    },
    resolvers: (state, getters) => (eventKey) => {
        return getters.getByEventAndTypeId(eventKey, RESOLVER_CONTACT_TYPE_ID)
    },
    getByEventAndTypeId: (state) => (eventKey, contactTypeId) => {
        return Object.values(state.local).filter(
            (item) => item.eventUuid === eventKey && item.contactTypeId === contactTypeId
        );
    },
    allContacts: (state, getters, rootState, rootGetters) => (eventKey) => {
        const eventContacts = [];
        const existingNumbers = new Set();

        const event = rootGetters['events/getByKey'](eventKey);
        if (!event) {
            return null;
        }

        const mainEventContacts = getters.getByEvent(event.uuid)
        if (mainEventContacts) {
            eventContacts.push(...mainEventContacts)
            mainEventContacts.forEach(contact =>
                existingNumbers.add(contact.number),
            )
        }

        const eventToEvents = rootGetters['eventToEvent/byTargetEventId'](event.id);
        if (eventToEvents) {
            eventToEvents.forEach((eventToEvent) => {
                const sourceEventCategoryId = eventToEvent.sourceEvent.eventCategoryId;

                const additionalContacts = orderBy(pickBy(
                    getters.getByEventId(eventToEvent.sourceEventId),
                    (contact) => {
                        const isInIncludedCategories = dzinCategoryIds.includes(sourceEventCategoryId);
                        return (
                            !existingNumbers.has(contact.number) &&
                            (isInIncludedCategories || includes([RESOLVER_CONTACT_TYPE_ID, DISP_DZIN_CONTACT_TYPE_ID, OIS_CONTACT_TYPE_ID], contact.contactTypeId))
                        );
                    }
                ), ['sort'], ['asc']);

                additionalContacts.forEach((contact) => {
                    if (!existingNumbers.has(contact.number)) {
                        eventContacts.push(contact)
                        existingNumbers.add(contact.number)
                    }
                })
            });
        }

        return eventContacts;
    },
    existInEvent: (state, getters) => {
        return (key, number) => {
            let contacts = getters.getByEvent(key);
            if (contacts) {
                return includes(map(contacts, 'number'), parseInt(number));
            }
            return false;
        }
    }
};

const actions = {
    async set({commit}, payload) {
        if (payload) {
            commit("MERGE_STATE", payload)
        }
    },
    save({dispatch, rootGetters }, payload) {

        if (payload.contactTypeId === undefined)
            payload.contactTypeId = 4;

        return new Promise((resolve) => {
            api.save('/v2/event-contacts', payload).then((result) => {
                let payload = {};
                const event = rootGetters['events/byId'](result.eventId);
                result.eventUuid = event.uuid;

                payload[String(result.id)] = result;
                dispatch('set', payload);
                dispatch('notifications/add', {type: 'success', message: 'Kontakt byl uložen'}, {root: true});
                resolve();
            });
        })
    },
    remove({commit}, id) {
        return new Promise((resolve) => {
            api.delete('/v2/event-contacts/' + id).then(() => {
                commit('remove', id);
                resolve();
            });
        })
    },
    resetState({commit}) {
        commit('resetState');
    },
};

const mutations = {
    MERGE_STATE(state, data) {
        stateMerge(state, data, 'local', false, true)
    },
    add(state, payload) {
        Vue.set(state.local, payload.key, payload.item);
    },
    update(state, payload) {
        forEach(payload.item, (value, key) => {
            state.local[payload.key][key] = value;
        });
    },
    remove(state, key) {
        if (state.local[key] !== undefined) {
            Vue.delete(state.local, key);
        }
    },
    resetState(state, payload) {
        Object.assign(state, getDefaultState());
        if (payload)
            Object.assign(state, payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
